module.exports = __webpack_public_path__ + "img/propaganda_bg.f6a5eab2.jpg";